import clx from 'classnames';
import { EditorState } from 'draft-js';
import { MegadraftEditor, Toolbar } from 'megadraft';
import React, { FC, Fragment, KeyboardEvent, useMemo } from 'react';
import {
  CUSTOM_DRAFT_ACTIONS,
  CUSTOM_DRAFT_DECORATORS,
  EDITABLE_DRAFT_PLACEHOLDER,
  EDITABLE_DRAFT_STYLE_MAP,
} from './constants';
import { useStyles } from './styles';
import { getEditableDraftContent } from './utils';

const CustomToolbar = (props: any) => {
  const classes = useStyles();
  return (
    <div className={classes.customToolbarWrapper}>
      <Toolbar {...props} />
    </div>
  );
};

interface EditableDraftProps {
  allowMultiline?: boolean;
  className?: string;
  content?: string | EditorState | null;
  onDraftChange?: (value: EditorState) => void;
  placeholder?: string;
  readonly?: boolean;
  withCustomToolbar?: boolean;
}

export const EditableDraft: FC<EditableDraftProps> = ({
  allowMultiline = false,
  className,
  content,
  onDraftChange,
  placeholder = EDITABLE_DRAFT_PLACEHOLDER,
  readonly,
  withCustomToolbar,
}) => {
  const classes = useStyles();
  const draftContent = useMemo(
    () =>
      EditorState.set(getEditableDraftContent(content), {
        decorator: CUSTOM_DRAFT_DECORATORS,
      }),
    [content],
  );

  const keyBindings = useMemo(
    () =>
      !allowMultiline
        ? [
            {
              name: 'newLine',
              action: () => {},
              isKeyBound: (e: KeyboardEvent<Element>) =>
                !e.metaKey && e.code === 'Enter',
            },
          ]
        : [],
    [allowMultiline],
  );

  return (
    <div className={clx(classes.root, className)}>
      <MegadraftEditor
        {...(withCustomToolbar && { Toolbar: CustomToolbar })}
        actions={CUSTOM_DRAFT_ACTIONS}
        customStyleMap={EDITABLE_DRAFT_STYLE_MAP}
        decorators={CUSTOM_DRAFT_DECORATORS}
        editorState={draftContent}
        keyBindings={keyBindings}
        onChange={onDraftChange}
        placeholder={placeholder}
        readonly={readonly}
        sidebarRendererFn={() => Fragment}
        spellCheck
      />
    </div>
  );
};
